import styled from '@emotion/styled';
import { Flex, Modal, Title, Col, Body, Button, Caption, SubTitle, LazyImage, Currency } from '@teko/ds-desktop';
import { formatDate } from '@teko/utils';
import i18next from 'i18next';
import React, { useState, useRef } from 'react';
import { t } from '../../i18n.es.js';
import { Shipment } from '../Shipment/Shipment.es.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const OrderShipments = (_a) => {
  var _b = _a, {
    shipments
  } = _b, rest = __objRest(_b, [
    "shipments"
  ]);
  var _a2, _b2, _c;
  const [shipmentVisible, setShipmentVisible] = useState();
  const isShowTransportProviderInfo = !!(shipmentVisible == null ? void 0 : shipmentVisible.transportProviderName) || !!(shipmentVisible == null ? void 0 : shipmentVisible.transportTrackingId);
  const isShowStatusHistories = !!((_a2 = shipmentVisible == null ? void 0 : shipmentVisible.statusChangeHistories) == null ? void 0 : _a2.length);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Flex, __spreadProps(__spreadValues({}, rest), {
    direction: "column",
    gapY: "s16"
  }), shipments.map((shipment) => /* @__PURE__ */ React.createElement(Shipment, {
    shipment,
    key: shipment.shipmentId,
    onshowMore: () => {
      setShipmentVisible(shipment);
    }
  }))), /* @__PURE__ */ React.createElement(Modal, {
    size: "l",
    visible: !!shipmentVisible,
    onClose: () => {
      setShipmentVisible(void 0);
    },
    cancelText: "",
    okText: t("\u0110\xF3ng"),
    onOk: () => {
      setShipmentVisible(void 0);
    },
    title: /* @__PURE__ */ React.createElement(Title, {
      weight: "medium"
    }, shipmentVisible == null ? void 0 : shipmentVisible.name, !!(shipmentVisible == null ? void 0 : shipmentVisible.shipmentId) && /* @__PURE__ */ React.createElement(React.Fragment, null, ":\xA0 ", "#", /* @__PURE__ */ React.createElement("strong", null, shipmentVisible.shipmentId))),
    showCloseIcon: false
  }, (isShowTransportProviderInfo || isShowStatusHistories) && /* @__PURE__ */ React.createElement(Flex, null, isShowTransportProviderInfo && /* @__PURE__ */ React.createElement(Col, {
    span: ((_b2 = shipmentVisible.statusChangeHistories) == null ? void 0 : _b2.length) ? 4.5 : 12,
    style: {
      paddingRight: "1rem"
    }
  }, /* @__PURE__ */ React.createElement(Flex, {
    direction: "column",
    gapY: "s8"
  }, !!shipmentVisible.transportProviderName && /* @__PURE__ */ React.createElement(Flex, {
    color: "textSecondary",
    gap: "s4"
  }, /* @__PURE__ */ React.createElement(Body, {
    weight: "regular"
  }, t("Giao h\xE0ng b\u1EDFi"), ":"), /* @__PURE__ */ React.createElement(Body, {
    weight: "bold"
  }, shipmentVisible.transportProviderName)), !!shipmentVisible.transportTrackingId && /* @__PURE__ */ React.createElement(Flex, {
    color: "textSecondary",
    gap: "s4"
  }, /* @__PURE__ */ React.createElement(Body, {
    weight: "regular"
  }, t("M\xE3 v\u1EADn \u0111\u01A1n"), ": \xA0"), /* @__PURE__ */ React.createElement(Button, __spreadValues({
    variant: "link",
    style: {
      textDecoration: "unset"
    }
  }, !!shipmentVisible.transportTrackingUrl ? { href: shipmentVisible.transportTrackingUrl } : {}), /* @__PURE__ */ React.createElement(Body, null, shipmentVisible.transportTrackingId))))), isShowStatusHistories && /* @__PURE__ */ React.createElement(ShipmentStatuses, {
    span: 7.5,
    style: {
      paddingLeft: "1rem"
    }
  }, /* @__PURE__ */ React.createElement(ShipmentStatusHistories, {
    histories: shipmentVisible.statusChangeHistories
  }))), !!((_c = shipmentVisible == null ? void 0 : shipmentVisible.invoiceItems) == null ? void 0 : _c.length) && /* @__PURE__ */ React.createElement(ProductListWrapper, {
    direction: "column",
    gapY: "s16",
    marginTop: "s16"
  }, shipmentVisible.invoiceItems.map((item) => /* @__PURE__ */ React.createElement(Flex, {
    key: item.sku,
    justify: "space-between",
    style: { width: "100%" },
    align: "start",
    gap: "s16"
  }, /* @__PURE__ */ React.createElement(Flex, {
    align: "start",
    gap: "s16"
  }, /* @__PURE__ */ React.createElement(ProductImage, {
    src: item.imageUrl || "",
    width: 80,
    height: 80,
    aspectRatio: 1,
    contain: true,
    borderRadius: 4
  }), /* @__PURE__ */ React.createElement(Flex, {
    direction: "column",
    gap: "s4"
  }, /* @__PURE__ */ React.createElement(Body, {
    weight: "medium"
  }, item.name), /* @__PURE__ */ React.createElement(Caption, {
    color: "textSecondary",
    weight: "medium"
  }, "SKU: ", item.sku), /* @__PURE__ */ React.createElement(Flex, {
    gap: "s4"
  }, !!item.sellerName && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Caption, {
    color: "textSecondary",
    weight: "medium"
  }, t("Cung c\u1EA5p b\u1EDFi"), " "), /* @__PURE__ */ React.createElement(Caption, {
    color: "link"
  }, item.sellerName))))), /* @__PURE__ */ React.createElement(Flex, {
    direction: "column",
    justify: "space-between",
    padding: ["s4", "s0"],
    gapY: "s16"
  }, /* @__PURE__ */ React.createElement(SubTitle, {
    weight: "bold"
  }, /* @__PURE__ */ React.createElement(StyledCurrency, {
    value: item.unitAfterTaxPrice || 0
  })), /* @__PURE__ */ React.createElement("div", {
    style: {
      textAlign: "right",
      width: "100%",
      maxWidth: "100%"
    }
  }, /* @__PURE__ */ React.createElement(Caption, {
    color: "textSecondary"
  }, "x", item.quantity || 1))))))));
};
const ShipmentStatuses = styled(Col)`
  border-left: 1px solid ${({ theme }) => theme.colors.divider};
`;
const DateTime = styled(Caption)`
  line-height: 24px;
`;
const ShipmentStatusHistories = ({ histories }) => {
  const ref = useRef(null);
  const [showMore, setShowMore] = useState();
  const onShowMore = () => {
    if (!showMore) {
      if (ref.current) {
        ref.current.style.maxHeight = "999px";
      }
      setShowMore(true);
    } else {
      if (ref.current) {
        ref.current.style.maxHeight = "90px";
      }
      setShowMore(false);
    }
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Wrapper, {
    ref
  }, /* @__PURE__ */ React.createElement(WrapperShipmentStatusHistories, {
    direction: "column",
    gapY: "s8"
  }, histories == null ? void 0 : histories.map((history, index) => /* @__PURE__ */ React.createElement(ShipmentStatusHistoryItem, {
    key: index,
    className: "history-item",
    align: "center",
    isActive: index === 0
  }, !!(history == null ? void 0 : history.changedAt) && /* @__PURE__ */ React.createElement(DateTime, {
    color: "textSecondary",
    weight: "medium",
    marginLeft: "s8",
    style: { width: 150 }
  }, formatDate(history.changedAt, i18next.language || "vi")), /* @__PURE__ */ React.createElement(Body, {
    marginBottom: "s4",
    color: "currentColor"
  }, history == null ? void 0 : history.status))))), ((histories == null ? void 0 : histories.length) || 0) > 3 && /* @__PURE__ */ React.createElement(Button, {
    variant: "link",
    paddingTop: "s16",
    onClick: onShowMore
  }, !showMore ? t("Xem th\xEAm") : t("Thu g\u1ECDn")));
};
const Wrapper = styled.div`
  max-height: 90px;
  overflow: hidden;
  transition: max-height 0.3s ease-in-out;
  margin-bottom: 0.5rem;
`;
const WrapperShipmentStatusHistories = styled(Flex)`
  position: relative;

  overflow: hidden;
  ::before {
    content: '';
    position: absolute;
    top: 9px;
    left: 2px;
    width: 1px;
    height: calc(100% - 36px);
    border-left: 1px solid ${({ theme }) => theme.colors.divider};
    transform: translateX(50%);
  }
  > div:last-child {
    margin-bottom: 0.75rem;
  }
`;
const ShipmentStatusHistoryItem = styled(Flex)`
  position: relative;
  padding-left: 0.75rem;
  color: ${({ theme, isActive }) => isActive ? theme.colors.link : theme.colors.textSecondary};
  ::before {
    content: '';
    position: absolute;
    top: 9px;
    left: 0;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: ${({ theme, isActive }) => isActive ? theme.colors.link : theme.colors.divider};
  }
`;
const ProductListWrapper = styled(Flex)`
  border-top: 1px solid ${({ theme }) => theme.colors.divider};
  padding-top: 1rem;
  margin-top: 1rem;
  max-height: 340px;
  overflow-y: auto;

  ::-webkit-scrollbar {
    width: 0px;
  }
`;
const ProductImage = styled(LazyImage)`
  border: 1px solid ${({ theme }) => theme.colors.divider};
  min-width: 80px;
`;
const StyledCurrency = styled(Currency)`
  font-size: unset;
`;

export { OrderShipments };
